module.exports = {
      id: "icon_check-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "images/js_src_vue/page_islide_landing/sprite.30abe696.svg#icon_check-usage",
      toString: function () {
        return this.url;
      }
    }